import { TrackingEventGtm } from '@sirius/common';

export interface TrackingEventEcommerce extends TrackingEventGtm {
    event: string;
    ecommerce: {
        [key: string]: unknown;
    };
}

export enum CartTrackingEventTypes {
    ADD_TO_CART = 'add_to_cart',
    REMOVE_FROM_CART = 'remove_from_cart',
}

export interface CartContentEvent extends TrackingEventEcommerce {
    event: CartTrackingEventTypes;
    ecommerce: {
        currency: string;
        value: string;
        items: [EcommerceTrackingItem];
    };
}

interface EcommerceTrackingItem {
    item_id: string;
    item_name: string;
    quantity: number;
    price?: string;
    item_brand?: string;
    item_category?: string;
}
